export default (
  object: Record<string, unknown>,
  key: string,
  newKey: string
): Record<string, unknown> => {
  const { [key]: old, ...rest } = object;
  return { [newKey]: old, ...rest };
};
